import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from "@ngrx/store";
import { Observable, catchError, mergeMap, of, switchMap } from "rxjs";
import * as UserActions from './user.actions';
import { UserService } from "@app/core/services/user.service";
import { User } from "@app/core/model/user/user.model";

@Injectable()

export class UserEffects {
    activeUser$ = createEffect((): Observable<Action> => {
        return this.actions$.pipe(
            ofType(UserActions.LOAD_USER_DATA),
            mergeMap((): Observable<Action> =>
                this.userService.getUserById$().pipe(
                    switchMap((response: User): Observable<Action> => {
                      return of(UserActions.SET_USER_DATA(response))
                    }),
                    catchError((): Observable<Action> => of())
                ))
        );
    }
    );

    constructor(
        private actions$: Actions,
        private userService: UserService) {
    }
}
